export default "__VITE_ASSET__DhdUbiN0__"